export default __webpack_public_path__ + "fbd38c0f8ee8272c004915a6b3018774.png";